import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { ListGroupViewImpl } from './listgroupview';
import { ListGroupCSSStyleImpl } from './listgroupcss';
import { GroupDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';
import { ListGroupViewModelImpl } from './viewmodel/grouprow/listgroupviewmodel';
import { ListGroupAPIModelImpl, ListGroupAPIModel } from './listgroupapimodel';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface ListGroupComponentProps extends UIComponentProps
{
    onCreateButtonClick():void;
    onDeleteButtonClick(groupdto:GroupDto):void;
    onViewButtonClick(groupdto:GroupDto):void;
    onEditButtonClick(groupdto:GroupDto):void;
}

export interface ListGroupComponentState extends UIComponentState
{
    listOfGroup:GroupDto[];
}
export interface ListGroupComponentHandler extends UIComponentHandler
{
    onCreateButtonClick():void;
    onDeleteButtonClick(groupdto:GroupDto):void;
    onViewButtonClick(groupdto:GroupDto):void;
    onEditButtonClick(groupdto:GroupDto):void;
    onDeleteConfirm(groupdto:GroupDto):void;
}

export class ListGroupComponent extends UIComponentImpl<ListGroupComponentProps, ListGroupComponentState, UIDataModel> implements ListGroupComponentHandler
{
    private listViewModel : ListGroupViewModelImpl;
    private listOfGroups :GroupDto[] =[];
    constructor(props: ListGroupComponentProps)
    {
        super(props);

        this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
        this.onEditButtonClick = this.onEditButtonClick.bind(this);
        this.onViewButtonClick = this.onViewButtonClick.bind(this);
        this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
        this.listViewModel = new ListGroupViewModelImpl(0,props.context, this.onDeleteButtonClick, this.onViewButtonClick, this.onEditButtonClick);

        this.state = {listOfGroup: []};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ListGroupViewImpl(this.listViewModel ,applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        
            return new ListGroupCSSStyleImpl(applicationContext);

        
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ListGroupAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentDidMount()
    {
        console.log("Component Did Mount of List Group ",(this.getAPIModel() as ListGroupAPIModel).getGroupList());
        (this.getAPIModel() as ListGroupAPIModel).getGroupList();
    }
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        // console.log("8888888888",);
        if(feature === APIFeatures.LIST_TONES)
        {   
            (this.getView() as ListGroupViewImpl).showLoader();
            this.setState({listOfGroup:data as GroupDto[]});
        }
        else if(feature === APIFeatures.DELETE_GROUP)
        {
            console.log("Onsuccess Group ",JSON.stringify(data));
            (this.getView() as ListGroupViewImpl).showLoader();

            (this.getView() as ListGroupViewImpl).showPopup(this.getContext().getResources().getString(Strings.caller_group_deleted_successfully), AlertType.SUCCESS, this.getContext().getResources().getString(Strings.ok));
  
            this.listOfGroups = this.state.listOfGroup.filter((t: any)=>
            {
                return (t as GroupDto).getGroupId() !== (data as GroupDto).getGroupId();
            });
             this.setState({listOfGroup:this.listOfGroups});
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void
    {
        if(feature === APIFeatures.LIST_TONES)
        {
            (this.getView() as ListGroupViewImpl).dismissLoader();

            (this.getView() as ListGroupViewImpl).showPopup(description, AlertType.ERROR, this.getContext().getResources().getString(Strings.ok));

        }
        else if(feature === APIFeatures.DELETE_GROUP)
        {
            (this.getView() as ListGroupViewImpl).dismissLoader();
            (this.getView() as ListGroupViewImpl).showPopup(description, AlertType.ERROR, this.getContext().getResources().getString(Strings.ok));

        }
        else{
            (this.getView() as ListGroupViewImpl).showPopup(description, AlertType.ERROR, this.getContext().getResources().getString(Strings.ok));

        }

    }
    onCreateButtonClick():void
    {
        this.props.onCreateButtonClick();
    }

    onDeleteButtonClick(groupdto:GroupDto):void
    {
        (this.getView() as ListGroupViewImpl).showDeletePopup(this.getContext().getResources().getString(Strings.are_you_sure_you_want_to_delete_the_group), AlertType.WARN, this.getContext().getResources().getString(Strings.ok),groupdto);

        // console.log("%%%%%%%%%%%%%%%%%Group",groupdto.getGroupName());
        //  this.listOfGroups = this.state.listOfGroup.filter((t: any)=>
        // {
        //     if((t as GroupDto).getGroupId() === groupdto.getGroupId())
        //     {

        //         (this.getAPIModel() as ListGroupAPIModel).deleteGroup(groupdto);
               
        //     }

        // }

        // );
        
    }

    onDeleteConfirm(groupdto:GroupDto)
    {
         console.log("%%%%%%%%%%%%%%%%%Group",groupdto.getGroupName());
         (this.getAPIModel() as ListGroupAPIModel).deleteGroup(groupdto);
    }
    onEditButtonClick(groupdto:GroupDto):void
    {
         this.props.onEditButtonClick(groupdto);
    }

    onViewButtonClick(groupdto:GroupDto):void
    {
        this.props.onViewButtonClick(groupdto);
    }

    
    // private getGroupDto()
    // {
    //     let groupDto = new GroupDtoImpl();
    //     groupDto.setGroupName("Test Group");

    //     let member1 = new MemberDetailsDtoImpl();
    //     member1.setMemberName("Test1");
    //     member1.setMsisdn("1234567890");

    //     let member2 = new MemberDetailsDtoImpl();
    //     member2.setMemberName("Test2");
    //     member2.setMsisdn("0987654321");

    //     let member3 = new MemberDetailsDtoImpl();
    //     member3.setMemberName("Test3");
    //     member3.setMsisdn("77863488445");

    //     let member4 = new MemberDetailsDtoImpl();
    //     member4.setMemberName("Test4");
    //     member4.setMsisdn("9876543212");
    //     groupDto.setMembersList([member1, member2,member3, member4]);

    //     return [groupDto, groupDto, groupDto, groupDto];
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/listgroup/listgroupcomponent.tsx